<template>
    <div
        ref="basic-faq-card"
        :class="[
            'basic-faq-card-container',
            theme,
            pageLang,
            {
                pc: isPc
            }
        ]"
    >
        <ul class="faq-list">
            <li v-for="(item, index) in faqList" :key="index" class="faq-item" :data-active="item.isExpand">
                <a href="javascript:;" class="heading" @click="handleShowContent(item)">
                    <p v-html="item.question"></p>
                    <icon :isActive="item.isExpand" :theme="theme" :activeColor="iconColor"></icon>
                </a>
                <collapse-transition v-if="contentCanFold">
                    <div v-show="displayContent(item)" class="content" v-html="item.answer"></div>
                </collapse-transition>
            </li>
        </ul>
    </div>
</template>
<script>
import CollapseTransition from './CollapseTransition/index.vue';
import Icon from './icon.vue';
import { isEditor, isPc, getPageLang } from '../fego/utils';
export default {
    name: 'basic-faq-card',
    components: {
        CollapseTransition,
        Icon
    },
    props: {
        theme: String,
        isFold: Boolean,
        iconColor: String,
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isPc: isPc(),
            isEditor: isEditor(),
            pageLang: getPageLang(),
            faqList: [],
            variable: window?.FEGORender?.store?.variable.data
        };
    },
    computed: {
        contentCanFold() {
            if (this.isEditor) {
                return !this.isFold;
            }
            return true;
        }
    },
    methods: {
        handleShowContent(item) {
            if (isEditor()) {
                return;
            }
            // 如果是点击当前索引，则隐藏当前点击的索引
            this.$set(item, 'isExpand', !item.isExpand); // 兼容处理 用$set
        },
        displayContent(item) {
            return this.isEditor || item.isExpand;
        },
        setFaqList() {
            const { resolve } = window?.FEGORender?.store?.variable || {};
            this.faqList =
            !this.isEditor && resolve
                ? this.list.map((item) => {
                    return {
                        ...item,
                        answer: resolve(item.answer),
                        question: resolve(item.question)
                    };
                })
                : this.list;
        }
    },
    watch: {
        variable: {
            handler() {
                this.setFaqList();
            },
            deep: true
        }
    },
    created() {
        this.setFaqList();
    }
};
</script>
<style lang="less" scoped>
@import './variables.less';
.basic-faq-card-container {
    height: auto !important;
    padding: var(--faq-card-padding);
}
.faq-list {
    .faq-item {
        padding: var(--list-item-padding);
        .heading {
            position: relative;
            cursor: pointer;
            display: block;
            color: var(--faq-head-color);
            font-size: var(--faq-head-font-size);
            line-height: var(--faq-head-line-height);
            font-family: var(--faq-head-font-family);
            padding-right: var(--faq-head-padding-right);
            .heading-icon {
                width: 0.26rem;
                height: 0.26rem;
                position: absolute;
                right: 0;
                top: calc(var(--faq-head-line-height) / 2 - var(--faq-head-font-size) / 2);
            }
        }
        .content {
            margin-top: var(--faq-content-margin-top);
            color: var(--faq-content-color);
            font-size: var(--faq-content-font-size);
            line-height: var(--faq-content-line-height);
            font-family: var(--faq-content-font-family);
            padding-right: var(--faq-content-padding-right);
        }
        + .faq-item {
            border-top: solid 0.01rem var(--border-color);
        }
    }
}
</style>
